export const CGST_PERCENTAGE = 2.5;
export const SGST_PERCENTAGE = 2.5;